module.exports = __webpack_public_path__ + "img/shutdown-icon.1fbd2d56.svg";